import { createFileRoute } from "@tanstack/react-router";
import { EditContent, ConsentPopupList } from "@/features/consent-solutions";

const Route = createFileRoute("/_authorized/consent-solutions/$csId/popup")({
  component: () => (
    <EditContent fullWidth>
      <ConsentPopupList />
    </EditContent>
  ),
});

export { Route };
